export const groupColors = [
  // Medium-toned colors - not too dark, not pale, not too bright
  // Mixed order to avoid all similar colors at the start
  "#1976D2", // Medium Blue
  "#D32F2F", // Medium Red
  "#388E3C", // Medium Green
  "#F57C00", // Medium Orange
  "#7B1FA2", // Medium Purple
  "#00897B", // Medium Teal
  "#E91E63", // Medium Pink
  "#0288D1", // Light Blue
  "#E64A19", // Medium Orange Red
  "#2E7D32", // Medium Green
  "#9C27B0", // Medium Purple
  "#00ACC1", // Medium Cyan
  "#C2185B", // Pink
  "#8D6E63", // Brown
  "#2196F3", // Blue
  "#C62828", // Red
  "#1E8449", // Green
  "#8E24AA", // Purple
  "#0097A7", // Teal
  "#AD1457", // Pink
  "#6D4C41", // Brown
  "#1565C0", // Blue
  "#A93226", // Red
  "#196F3D", // Green
  "#5E35B1", // Deep Purple
  "#26A69A", // Light Teal
  "#880E4F", // Deep Pink
  "#5D4037", // Brown
  "#0277BD", // Blue
  "#922B21", // Red
  "#145A32", // Green
  "#6C3483", // Purple
  "#00838F", // Cyan
  "#546E7A", // Blue Grey
  "#3E2723", // Dark Brown
  "#2874A6", // Blue
  "#78281F", // Red
  "#0E6655", // Green
  "#7D3C98", // Purple
  "#00BCD4", // Cyan
  "#78909C", // Blue Grey
  "#607D8B", // Blue Grey
  "#21618C", // Blue
  "#641E16", // Red
  "#66BB6A", // Light Green
  "#633974", // Purple
  "#009688", // Teal
  "#455A64", // Blue Grey
  "#1B4F72", // Blue
  "#EF5350", // Light Red
  "#7CB342", // Green
  "#512E5F", // Purple
  "#5C6BC0", // Indigo
  "#37474F", // Dark Slate
  "#154360", // Blue
  "#E53935", // Red
  "#558B2F", // Green
  "#4A235A", // Purple
  "#3949AB", // Indigo
  "#263238", // Dark Blue Grey
  "#42A5F5", // Light Blue
  "#FFA726", // Light Orange
  "#43A047", // Green
  "#AB47BC", // Light Purple
  "#3F51B5", // Indigo
  "#1B2631", // Dark Blue Grey
  "#FB8C00", // Orange
  "#757575", // Medium Grey
  "#FF9800", // Orange
  "#616161", // Grey
  "#B9770E", // Orange
  "#7F8C8D", // Grey
  "#935116", // Orange
  "#95A5A6", // Light Grey
  "#6E2C00", // Orange
  "#85929E", // Blue Grey
  "#5B2C0F", // Orange
  "#839192", // Grey
  "#7D7D7D", // Medium Grey
  "#6C6C6C", // Grey
  "#5A5A5A", // Dark Grey
  "#566573", // Grey
  "#5D6D7E", // Blue Grey
  "#424242", // Dark Grey
  "#4A4A4A", // Darker Grey
];
